import { graphqlRequest, hasGraphQLErrors, hasGraphQLNetworkError } from '~/adapters/graphqlRequest';
import { httpRequest } from '~/adapters/httpRequest';

import { FetchAccountDocument } from '~/gql/graphql';

import { accountFrom } from '../transformers/account.transformer';
import { permissionsFrom } from '../transformers/permission.transformer';

const fetchMyAccount = async () => {
  try {
    // TODO: Aggregate all account data from this endpoint, not just adminPermissions.
    const accountRes = await httpRequest<any>('/api/user/v1/users/me');

    if (accountRes?.error) return Promise.reject(accountRes.error);
    if (accountRes?.errors) return Promise.reject(accountRes.errors[0]);

    return accountRes.user;
  } catch (e: any) {
    console.error(e?.message);
    throw e;
  }
};

const fetchLegacyAccount = async (userId: number) => {
  try {
    // TODO: Eventually move all data currently being fetched from this network
    // to the /api/user/v1/users/me endpoint.
    const accountRes = await graphqlRequest<any>(FetchAccountDocument, { userId });

    if (hasGraphQLNetworkError(accountRes)) return Promise.reject(accountRes.error);
    if (hasGraphQLErrors(accountRes)) return Promise.reject(accountRes.errors[0]);

    return accountRes?.data?.user;
  } catch (e: any) {
    console.error(e?.message);
    throw e;
  }
};

const fetchCurrentAccount = async () => {
  const myAccount = await fetchMyAccount();
  const legacyAccount = await fetchLegacyAccount(myAccount.id);

  const { account, company } = accountFrom(legacyAccount);
  const permissions = permissionsFrom(
    legacyAccount?.globalActions,
    legacyAccount?.permissions,
    myAccount?.adminPermissions,
    legacyAccount?.canManageMailingList,
  );

  return {
    account,
    company,
    permissions,
  };
};

export const accountQueries = {
  fetchMyAccount,
  fetchLegacyAccount,
  fetchCurrentAccount,
};
